import React from 'react';

export const TruckIcon = () => <i className='icon icon-Truck' />;
